import {ID, Response} from '../../../../../../_metronic/helpers'
import {FieldProps} from '../../../../../../_component/Form'

export type Comment = {
  id?: ID
  name?: string
  note?: string
  status?: boolean
}

export type CommentsQueryResponse = Response<Array<Comment>>

export const fields: FieldProps[] = [
  {name: 'name', label: 'Name', required: true, table: true, sortable: true, full: true},
  {
    name: 'status',
    label: 'Status',
    type: 'switch',
    truthValue: 'Active',
    falseValue: 'Inactive',
    table: true,
    sortable: true,
    full: true,
  },
  {name: 'note', label: 'Note', type: 'textarea', full: true, table: true},
]
